import { render } from "./IframeContainer.vue?vue&type=template&id=798f2f50&scoped=true"
import script from "./IframeContainer.vue?vue&type=script&lang=js"
export * from "./IframeContainer.vue?vue&type=script&lang=js"

import "./IframeContainer.vue?vue&type=style&index=0&id=798f2f50&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798f2f50"]])

export default __exports__